import { AccredibleApiService } from '@accredible-frontend-v2/services/api';
import { Injectable } from '@angular/core';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TrackLink } from './tracking.model';

@Injectable({
  providedIn: 'root',
})
export class AccredibleTrackingApiService extends AccredibleApiService {
  linkedInShare(credentialId: number): void {
    const endpoint = '/v1/credential-net/credential_analytics/linkedin_certificate_shared';
    this._post(endpoint, { credential_id: credentialId })
      .pipe(
        catchError(() => {
          console.error('Failed to track: ' + endpoint);
          return EMPTY;
        }),
      )
      .subscribe();
  }

  linkedInAddToProfile(credentialId: number): void {
    const endpoint = '/v1/credential-net/credential_analytics/linkedin_certificate_added';
    this._post(endpoint, { credential_id: credentialId })
      .pipe(
        catchError(() => {
          console.error('Failed to track: ' + endpoint);
          return EMPTY;
        }),
      )
      .subscribe();
  }

  trackExternalLink(trackLink: TrackLink): void {
    const endpoint = '/v1/credential-net/credential_analytics/track_link';
    this._post(endpoint, trackLink)
      .pipe(
        catchError(() => {
          console.error('Failed to track: ' + endpoint);
          return EMPTY;
        }),
      )
      .subscribe();
  }
}
